/**
 * A single tab page. It renders the passed template
 * via the @Input properties by using the ngTemplateOutlet
 * and ngOutletContext directives.
 */

import {Component, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-dynamic-tab',
  template: `
    <div [hidden]="!active">
      <router-outlet></router-outlet>
      <ng-content></ng-content>
      <ng-container [ngComponentOutlet]="template" *ngIf="template">
      </ng-container>
    </div>
  `
})
export class TabComponent {
  @Input('tabTitle') tabTitle: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() template;
  @Input() url;
  @Output() close = new EventEmitter();
  public closeSelf() {
    this.close.emit(this);
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/tab/tab/tab.component.ts